/*
  One Tooth World — track order form (PRD 8.8).
  If data-template holds a tracking URL, redirect to it with {order} replaced by the order number
  (leading # removed). Otherwise the form submits to the account login page.
*/
class OtwTrackOrder extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('[data-otw-track-form]');
    this.form?.addEventListener('submit', (event) => this.onSubmit(event));
  }

  onSubmit(event) {
    const order = this.querySelector('[data-otw-track-order]').value.trim().replace(/^#/, '');
    const email = this.querySelector('[data-otw-track-email]');
    const error = this.querySelector('[data-otw-track-error]');
    const template = this.dataset.template;
    if (!order || !email.checkValidity() || !email.value) {
      event.preventDefault();
      error.hidden = false;
      (order ? email : this.querySelector('[data-otw-track-order]')).focus();
      return;
    }
    error.hidden = true;
    if (template && template.includes('{order}')) {
      event.preventDefault();
      window.location.href = template.replace('{order}', encodeURIComponent(order));
    }
  }
}

if (!customElements.get('otw-track-order')) customElements.define('otw-track-order', OtwTrackOrder);
